<template>
  <div class="counter-container">
    <div class="text">Стоимость сегмента</div>
    <div class="count">
      <template v-if="cost !== null && cost !== undefined">
        <span class="value">{{ formatNumber(cost) }}</span>
        <span class="unit"> ₽ </span>
      </template>
      <template v-else>
        <span class="value">—</span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { formatNumber } from "@/services/utils/Strings";

const props = defineProps<{
  settedCost: number | null | undefined;
}>();

const emits = defineEmits(["updateSegmentCost"]);

const cost = ref<number | null | undefined>(props.settedCost);

watch(
  () => props.settedCost,
  (newValue) => {
    cost.value = newValue;
  }
);

const updateCost = (newCost: number) => {
  cost.value = newCost;
  emits("updateSegmentCost", newCost);
};

defineExpose({
  updateCost,
});
</script>

<style lang="scss" scoped>
.counter-container {
  width: 240px;
  background-color: $main-link-color;
  border-radius: 16px;
  padding: 12px 21px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

  .text {
    line-height: 1rem;
    color: $main-light-color;
    margin-top: 14px;
  }

  .count {
    padding: 22px 0;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 2rem;
    font-style: normal;
    font-weight: 700;
    line-height: 135%;
    color: white;
    letter-spacing: 0.28px;
    white-space: nowrap;
    display: flex;
    align-items: baseline;
    flex-wrap: nowrap;

    .value {
      flex-shrink: 1;
      min-width: 0;
    }

    .unit {
      font-size: 1.5rem;
      font-weight: normal;
      opacity: 0.9;
      margin-left: 8px;
      flex-shrink: 0;
    }
  }
}
</style>
